/**
 * Client-side icon utilities.
 * Uses Lucide icons (lucide.dev) - ISC License.
 */

import { iconPaths, type IconName } from "../shared/icon-paths";

export type { IconName };

/**
 * Creates an SVG icon element for client-side use.
 */
export function createIcon(name: IconName, size = 24): SVGSVGElement {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", String(size));
  svg.setAttribute("height", String(size));
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "2");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");

  const paths = iconPaths[name];
  if (paths) {
    svg.innerHTML = paths;
  }

  return svg;
}

/**
 * Returns the SVG markup string for an icon.
 * Useful for innerHTML injection.
 */
export function iconHtml(name: IconName, size = 24): string {
  const paths = iconPaths[name];
  if (!paths) return "";

  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
}

/**
 * Returns the raw SVG path data for an icon.
 */
export function getIconPaths(name: IconName): string {
  return iconPaths[name] || "";
}
